/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.SubAccountsResponse,
  (requestParams: vp.SubAccountsRequest) => void,
  () => void,
  (requestParams: vp.SubAccountsRequest, bearer?: string) => Promise<vp.SubAccountsResponse>,
];

function useFetchSubAccounts({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.SubAccountsRequest>();
  const [response, setResponse] = useState<vp.SubAccountsResponse>({
    ErrorMessage: '',
    Success: false,
    ParentAccount: '',
    Subaccounts: [],
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.SubAccountsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchSubAccounts(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.SubAccountsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        ParentAccount: '',
        Subaccounts: [],
      });
    },
    async (requestParams: vp.SubAccountsRequest, bearer?: string) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchSubAccounts(requestParams, source, bearer);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchSubAccounts);
